export default __webpack_public_path__ + "static/media/menu-icon.b4885861.svg";